import { render, staticRenderFns } from "./waitTakeApplication.vue?vue&type=template&id=671ca227&scoped=true"
import script from "./waitTakeApplication.vue?vue&type=script&lang=js"
export * from "./waitTakeApplication.vue?vue&type=script&lang=js"
import style0 from "./waitTakeApplication.vue?vue&type=style&index=0&id=671ca227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ca227",
  null
  
)

export default component.exports